// extracted by mini-css-extract-plugin
export default {"importProducts":"importFile_importProducts__gbjm7"};